import React from 'react';
import { LoaderContent, LoaderStyled, LoaderWrapper, PosterLoader } from './Loader.styled';

interface Props {
    poster?: string;
    className?: string;
    size?: number;
    children?: React.ReactNode;
}

export default function Loader({ poster, className = '', size = 40, children }: Props) {
    if (poster) {
        return (
            <PosterLoader
                style={{
                    backgroundImage: `url(${poster})`,
                }}
            />
        );
    }
    return (
        <LoaderWrapper className={className} style={{ width: size, height: size }}>
            <LoaderStyled />
            <LoaderContent>{children}</LoaderContent>
        </LoaderWrapper>
    );
}
